import { render, staticRenderFns } from "./islem_gecmisleri.vue?vue&type=template&id=34ed5732&"
import script from "./islem_gecmisleri.vue?vue&type=script&lang=js&"
export * from "./islem_gecmisleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports